// This array must be same as Businesses of Backend
export const Businesses = [
    'home',
    'revolution',
    'destination',
    'place_type',
    'place',
    'activity',
    'agency',
    'agency_schedule',
    'agency_client',
    'agency_news',
    'service_type',
    'service',
    'event',
    'news',
    'experience',
    'folkways_type',
    'folkways',
    'media',
    'blog',
    'about',
    'special',
    'information',
    'home_ads',
    'banner',
    'introduction',
    'external',
    'contact_office',
    'article',
    'search'
];
// This array is category list needed to search by business in portfolio page.
// This array must be same as Businesses of Backend
export const BS_CATEGORY = [
    'all',
    'destination',
    'place',
    'activity',
    'agency',
    'agency_news',
    'service',
    'event',
    'news',
    'experience',
    'folkways',
    'article'
];
export const BsLink = [
    'home',
    'revolution',
    'destination',
    'place_type',
    'place',
    'activity',
    'agency',
    'agency_schedule',
    'agency_client',
    'blog/agency_news',
    'service_type',
    'service',
    'blog/event',
    'blog/news',
    'blog/experience',
    'folkways_type',
    'blog/folkways',
    'media',
    'blog',
    'about',
    'special',
    'information',
    'home_ads',
    'banner',
    'introduction',
    'external',
    'contact_office',
    'blog/article'
];

export const Pages = [
    'home',
    'revolution',
    'revolution_detail',
    'destination',
    'destination_detail',
    'place',
    'place_detail',
    'blog',
    'blog_detail',
    'service',
    'service_detail',
    'folkway',
    'folkway_detail',
    'agency',
    'agency_detail',
    'activity',
    'activity_detail',
    'informations',
    'information_detail',
    'news_detail',
    'event_detail',
    'testimonial_detail',
    'agency_news_detail',
    'article_detail',
    'media',
    'about',
    'special',
    'special_detail'
];

export const PagesForCaption = [
    'home',
    'revolution',
    'destinations',
    'destination_detail',            
    'place_detail',
    'service_detail',
    'activity',
    'activity_detail',
    'blogs',
    'blog_detail',
    'special',
    'about',    
    'agency_detail'
];

export const CaptionCodes = [
    ['home_news', 
        'home_testimony', 
        'home_agency', 
        'home_photo_article', 
        'home_information'],
    ['leadership_leadership'],
    ['destinations_destination'],
    ['destination_places',
        'destination_experience',
        'destination_hotels',
        'destination_restaurant',
        'destination_etc_service',
        'destination_place_cat',
        'destination_other_destinations'],            
    ['place_other_places',
        'place_experience'],
    ['service_other_services',
        'service_experience'],
    ['activity_activities'],
    ['activity_other_activities'],
    ['blog_category',
        'blog_other_blogs'],
    ['blog_single_other_blogs'],
    ['special_list'],
    ['about_org',
        'about_agency_list'],    
    ['agency_news',
        'agency_schedule',
        'agency_about_us',
        'agency_clients',
        'agency_other_agencies']
];